module.exports = __webpack_public_path__ + "static/img/logo3gtapp_new_20260710.f0e9c29e.png";